import { render, staticRenderFns } from "./SendMessageDetailContent.vue?vue&type=template&id=372c3519&scoped=true&lang=pug"
import script from "./SendMessageDetailContent.vue?vue&type=script&lang=ts"
export * from "./SendMessageDetailContent.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageDetailContent.vue?vue&type=style&index=0&id=372c3519&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372c3519",
  null
  
)

export default component.exports